{
  "title": "Stock Transfers",
  "subtitle": "Move stock between warehouses.",
  "add": "New Transfer",
  "edit": "Edit",
  "complete": "Complete",
  "table": {
    "number": "Transfer #",
    "from": "From Warehouse",
    "to": "To Warehouse",
    "date": "Date",
    "lines": "Lines",
    "status": "Status"
  },
  "form": {
    "fromWarehouse": "From Warehouse",
    "toWarehouse": "To Warehouse",
    "material": "Material",
    "fromLocation": "From Location",
    "toLocation": "To Location",
    "none": "None",
    "quantity": "Quantity",
    "addLine": "Add Line",
    "resolvedBatch": "Batch: {{batchNo}}",
    "resolvedClient": "Client: {{clientName}}",
    "areaHint": "Pick the area to move stock out of — the whole warehouse, one zone, or a single rack or bin. Its stock is listed below with the quantity available to move.",
    "barcodeAreaHint": "Barcode Required is on. Pick the area and a material, then scan each unit — scanned units are ticked and moved to the top. Choose one destination below for all of them. You can submit whatever you have scanned so far.",
    "zone": "Zone",
    "rackOrBin": "Rack / Bin",
    "wholeWarehouse": "Whole warehouse",
    "anyLocation": "Any rack or bin",
    "itemsTitle": "Available in this area",
    "unitsTitle": "Units in this area",
    "noStockInArea": "No available stock in the selected area.",
    "noUnitsInArea": "No barcoded units of this material in the selected area.",
    "stockMeta": "{{location}} · Zone {{zone}} · Batch {{batch}} · Available {{available}}",
    "unitMeta": "Qty {{qty}} · {{source}} label · Batch {{batch}} · {{location}}",
    "scanDuplicate": "That unit has already been scanned.",
    "selectedCount": "{{count}} line(s) ready to transfer.",
    "selectFromWarehouse": "Select a source warehouse to begin.",
    "qty": "Qty",
    "scanBarcode": "Scan Barcode",
    "scanBarcodeHelper": "Scan each unit in turn. It is ticked and lifted to the top of the list.",
    "scanNotInList": "That barcode is not one of the units listed for this material and area.",
    "scannedOfTotal": "{{scanned}} / {{total}}",
    "destinationType": "Destination",
    "typeAll": "All",
    "typeZone": "Zone",
    "typeRack": "Rack",
    "typeBin": "Bin",
    "destinationForAll": "Move all scanned units to",
    "destinationForAllHelper": "Applies to every scanned unit — no need to set a location per barcode."
  },
  "save": "Save",
  "cancel": "Cancel"
}
